(function () {
  function syncFutureletterInclusion(menu, inclusion) {
    if (!menu || !inclusion) return;
    var selected = menu.options && menu.selectedIndex >= 0
      ? menu.options[menu.selectedIndex]
      : null;
    inclusion.hidden = !(selected && selected.id === "t-price");
  }

  function boot() {
    var forms = document.querySelectorAll("#ReservationForm");
    for (var i = 0; i < forms.length; i++) {
      var menu = forms[i].querySelector('[id$="-menu"]');
      var inclusion = forms[i].querySelector("[data-reservation-futureletter-inclusion]");
      if (!menu || !inclusion) continue;
      syncFutureletterInclusion(menu, inclusion);
      menu.addEventListener("change", function (event) {
        var form = event.currentTarget.closest("#ReservationForm");
        syncFutureletterInclusion(
          event.currentTarget,
          form && form.querySelector("[data-reservation-futureletter-inclusion]")
        );
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
